import React from 'react'

import {Row} from 'react-flexbox-grid'

const GridRow = (props) => {
  return <Row {...props} style={{paddingLeft: '0', paddingRight: '0', marginRight: '-16px', marginLeft: '-16px'}} />
}

export default GridRow
